import React, {
  Attributes, FunctionComponent, ReactNode, createElement, type JSX,
} from 'react';
import { Row, Spinner } from 'react-bootstrap';
import Snackbar from 'components/DesignSystem/Snackbar';
import './EmptyListAlert.scss';

interface EmptyListAlertProps {
  // eslint-disable-next-line react/require-default-props
  array?: unknown[];
  message: string,
  component: unknown,
  isFetching: boolean,
  listEnded: boolean,
}

export default function EmptyListAlert({
  component,
  message,
  array,
  isFetching,
  listEnded,
}: EmptyListAlertProps) {
  let returnedElement: ReactNode;
  if (isFetching || array?.length) {
    returnedElement = (
      <>
        {array && array.map(
          (element) => createElement(
            component as FunctionComponent,
            element as Attributes,
          ),
        )}
        {isFetching && (
          <Row>
            <Spinner className="mx-auto" />
          </Row>
        )}
        {listEnded && (
          <Row>
            <Snackbar>
              Exibindo todos os itens disponíveis
            </Snackbar>
          </Row>
        )}
      </>
    );
  } else {
    returnedElement = (
      <Snackbar>
        { message }
      </Snackbar>
    );
  }
  return returnedElement as JSX.Element;
}
